module.exports = __webpack_public_path__ + "img/360-degrees.06ddcef8.svg";